<template>
	<div>
		<component :is="layout">
			<router-view />
		</component>
	</div>
</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue";
import CompanyLayoutVertical from "@core/layouts/layout-vertical/CompanyLayoutVertical.vue";
import HatcheryLayoutVertical from "@core/layouts/layout-vertical/HatcheryLayoutVertical.vue";
// import AppCustomizer from "@core/layouts/components/app-customizer/AppCustomizer.vue";
import { $themeConfig } from "@themeConfig";
import { getRoleSlug } from "@/auth/utils";

export default {
	components: {
		// AppCustomizer,
		LayoutVertical,
		CompanyLayoutVertical,
		HatcheryLayoutVertical,
	},
	data() {
		return {
			showCustomizer: $themeConfig.layout.customizer,
			userData: JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null"),
			enabledModulesPollTimer: null,
		};
	},
	created() {
		// Company-level module gating (nav visibility) — fetch immediately on
		// app boot (Vuex resets to null on every full page load), then poll so
		// a super-admin toggle shows up here within ~20s even without a page
		// reload. This is the "near-instant" fallback layer — the FCM push
		// (mobile) is the fast path, this is what keeps web (and any missed
		// push) self-correcting without needing real push infra for web.
		this.$store.dispatch("features/fetchEnabledModules");
		this.enabledModulesPollTimer = setInterval(() => {
			this.$store.dispatch("features/fetchEnabledModules");
		}, 20000);
	},
	beforeDestroy() {
		if (this.enabledModulesPollTimer) clearInterval(this.enabledModulesPollTimer);
	},
	computed: {
		isSuperAdmin() {
			// this.userData.role is a display label ("Super Admin"), not the
			// slug — comparing it to "super_admin" directly never matched, so
			// super_admin always fell through to the owner's
			// CompanyLayoutVertical (wrong sidebar, wrong nav items).
			return getRoleSlug(this.userData) === "super_admin";
		},
		layout() {
			if (this.isSuperAdmin) {
				if (this.$route.path.includes("manage-farm")) {
					return "hatchery-layout-vertical";
				} else if (this.$route.path.includes("manage-company")) {
					return "company-layout-vertical";
				} else {
					return "layout-vertical";
				}
			} else {
				if (this.$route.path.includes("manage-farm")) {
					return "hatchery-layout-vertical";
				} else {
					return "company-layout-vertical";
				}
			}
		},
	},
};
</script>
